import { render, staticRenderFns } from "./RecordStaff.vue?vue&type=template&id=39af8886&scoped=true&"
import script from "./RecordStaff.vue?vue&type=script&lang=js&"
export * from "./RecordStaff.vue?vue&type=script&lang=js&"
import style0 from "./RecordStaff.vue?vue&type=style&index=0&id=39af8886&scoped=true&lang=scss&ref=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39af8886",
  null
  
)

export default component.exports